import React, { useState, useContext } from 'react'
import {useHistory} from "react-router-dom";
import Hotkeys from "react-hot-keys";

import {postByUrl} from "../../../../v3MethodsService";

import { Toast } from 'primereact/toast'; //использовать для сообщений от бэка
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";

import { GlobalContext } from '../../../../ctx'
        
import './style.scss'

const SendEmail = ({  }) => {
    const history = useHistory()

    const [email, setEmail] = useState('')
    const [error, setError] = useState(false)

    const [global, setGlobal] = useContext(GlobalContext)
    const toast = global && global.toast ? global.toast : {}

    const sendHandler = async () => {
        const resp = await postByUrl('recovery', {"email": email})
        if (resp && resp.success) {
            setError(false)
            toast.show({ severity: "success", life: 4000, summary: "Письмо для восстановления пароля отправлено на почту" });
            history.push('/login')
            return
        }
        setError(true)
        toast.show({ severity: "error", life: 4000, summary: "Аккаунт с данной почтой еще не создан" });
    }

    const onKeyDown = async (e) => {
        if ((e === 'Enter' || e.key === 'Enter')) {
            await sendHandler()
        }
    }

    return (
        <div className='auth2__container recover-send-email'>
            <div className='auth2__title'>
                Восстановление доступа
            </div>
            <Hotkeys keyName="Enter" onKeyDown={onKeyDown}>
                <div className='auth2__inputs'>
                    <InputText value={email || ''} id='email' onChange={(e) => setEmail(e.target.value)} placeholder='Введите почту' onKeyDown={onKeyDown} className={`auth2__input${error ? ' auth2__input_invalid' : ''}`}/>
                    <Button label='Восстановить доступ' onClick={sendHandler} className='auth2__button' disabled={!(email && isValidEmail(email))} />
                </div>
            </Hotkeys>
        </div>
    )
}

const isValidEmail = (email) => {
    const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/
    return regex.test(email);
}

export default SendEmail;
